import React from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router';
import { checkIsActive } from '../../utils';
import { useLayout } from '../../layout/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
	to: string;
	title: string;
	icon?: any
	fontIcon?: string;
	hasBullet?: boolean;
	children?: React.ReactElement;
}

const AsideMenuItemWithSub = (
	{
		children,
		to,
		title,
		icon,
		fontIcon,
		hasBullet
	}: Props): React.ReactElement => {
	const { pathname } = useLocation();
	const isActive = checkIsActive(pathname, to);
	const { config } = useLayout();
	const { aside } = config;

	return (
		<div
			className={clsx('menu-item', { 'here show': isActive }, 'menu-accordion')}
			data-kt-menu-trigger="click"
		>
      <span className="menu-link">
        {hasBullet && (
	        <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}
	      {icon && <FontAwesomeIcon icon={icon} className={clsx('me-3 menu-icon', isActive ? 'text-danger' : 'text-muted')}/>}
	      {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
	      <span className="menu-title">{title}</span>
        <span className="menu-arrow"></span>
      </span>
			<div className={clsx('menu-sub menu-sub-accordion', { 'menu-active-bg': isActive })}>
				{children}
			</div>
		</div>
	);
};

export { AsideMenuItemWithSub };
